import { render } from "./RetrievePass.vue?vue&type=template&id=bf106c4a&ts=true"
import script from "./RetrievePass.vue?vue&type=script&lang=ts"
export * from "./RetrievePass.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\benja\\Desktop\\Renault\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__